const BgpolygonMob = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="199"
      height="371"
      viewBox="0 0 199 371"
      fill="none"
    >
      <path
        d="M107.53 -3.62428C111.246 -16.1871 125.836 -21.8441 137.05 -15.07L479.946 192.071C494.732 201.003 492.003 223.217 475.494 228.303L30.7909 365.323C15.5383 370.022 1.19609 355.841 5.72337 340.536L107.53 -3.62428Z"
        stroke="#310F21"
        stroke-width="8"
      />
    </svg>
  );
};

export default BgpolygonMob;
